// extracted by mini-css-extract-plugin
module.exports = {"ratingWrp":"slider_ratingWrp__1uMM1","ratingTextWrp":"slider_ratingTextWrp__G502n","ratingLabel":"slider_ratingLabel__2FuAV"};